import PropTypes from 'prop-types';
import React from 'react';
import {
  FDHeadlineText, FDIcon, FDLabelText, FDPaper, FDStack,
} from '@facet-wealth/design';
import { dataAttrs } from 'Helpers/Testing';
import useMobileLayout from 'Hooks/useMobileLayout';

const GroupTotalValueCard = ({
  label,
  value,
  icon,
}) => {
  const isMobile = useMobileLayout();
  return (
    <FDPaper
      padding={2}
      appearance={'flat'}
      color={'info'}
      flexGrow={1}
      width={'100%'}
      {...dataAttrs('total-value-card')}
    >
      <FDStack
        direction={'column'}
        spacing={1}
        alignItems={isMobile ? 'flex-start' : 'center'}
        justifyContent={isMobile ? 'space-between' : 'center'}
        paddingX={isMobile ? 2 : 0}
        width={'100%'}
        wrap
      >
        <FDStack direction={isMobile ? 'row' : 'column'} spacing={1} alignItems={'center'}>
          <FDIcon icon={icon} color={'textSecondary'} size={isMobile ? 'md' : 'lg'} alignSelf={'center'} />
          <FDLabelText value={label} size={'lg'} color={'textSecondary'} />
        </FDStack>
        <FDHeadlineText value={value} />
      </FDStack>
    </FDPaper>
  );
};

GroupTotalValueCard.defaultProps = {};

GroupTotalValueCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

export { GroupTotalValueCard };
